import { render, staticRenderFns } from "./DisplayImagesCarousel.vue?vue&type=template&id=5f6edcdc&scoped=true"
import script from "./DisplayImagesCarousel.vue?vue&type=script&lang=ts"
export * from "./DisplayImagesCarousel.vue?vue&type=script&lang=ts"
import style0 from "./DisplayImagesCarousel.vue?vue&type=style&index=0&id=5f6edcdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6edcdc",
  null
  
)

export default component.exports